























import { Component, Emit, Prop, Vue, PropSync } from "vue-property-decorator";

@Component
export default class GsModalDialog extends Vue {
  @Prop({ default: "primary" }) btnColor!: string;
  @Prop({ default: "400" }) width!: number;
  @Prop({ default: false }) fullscreen!: boolean;
  @Prop({ default: false }) scrollable!: boolean;
   
  @PropSync("openDialog", { required: true, default: false })
  dialog!: boolean;

  @Emit("action")
  avancar() {}
}
